import React, {memo, useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import AutoSizer from "react-virtualized-auto-sizer";

import { getFromApiAsync } from '../../helpers/apiHelper';
import { getColorByIndex, formatNumber, formatNumber_N1 } from '../../helpers/utils';

export default memo(function IDXHist(props) {

    const { indexCode } = props;
    const [indexesHist, setIndexesHist] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const refIndexCode = useRef(null);
    
    const {t} = useTranslation();

    // Neu ngay bat he thong la ngay gd thi lay them trong ngay. Con lai lay hist
    const startupDate = useSelector(state => state.gShared.startupDate ?? '');
    const tradingDate = useSelector(state => state.gShared.tradingDate ?? '');
    const vnTradingDate = (new Date(tradingDate)).toLocaleDateString('en-GB');

    const i_counter = useSelector(state => state.gIndex.indexInfos.find(item => startupDate === tradingDate && item.indexCode === indexCode)?.counter);
    const indexInfo = useSelector(state => state.gIndex.indexInfos.find(item => startupDate === tradingDate && item.indexCode === indexCode)) ?? {};

    let displayDatas = [...indexesHist];
    if(indexInfo && tradingDate !== "" && displayDatas.findIndex(x => x.tradingDate === vnTradingDate) < 0) {
        displayDatas.splice(0, 0, {
            tradingDate: vnTradingDate,
            priorIndex: indexInfo.priorIndex,
            currentIndex: indexInfo.currentIndex,
            changeIndex: indexInfo.changeIndex,
            pctChangeIndex: indexInfo.pctChangeIndex,
            openIndex: indexInfo.openIndex,
            highestIndex: indexInfo.highestIndex,
            lowestIndex: indexInfo.lowestIndex,
            closeIndex: indexInfo.closeIndex,
            totalTradedQtty: indexInfo.totalTradedQtty,
            totalTradedValue: indexInfo.totalTradedValue,
        })
    }

    //
    const _getDatas = (getIndexCode) => {
        if(isLoading) return;

        setIsLoading(true);

        // Init call api get data
        getFromApiAsync("pr/indexhist/" + getIndexCode).then(res => {
            if(getIndexCode === refIndexCode.current) {
                setIndexesHist(res.data);
                setIsLoading(false);
            }
        }).catch(err => {
            setIsLoading(false);
        });
    }

    //
    useEffect(() => {
        if(refIndexCode.current != indexCode) {
            setIsLoading(false);
            setIndexesHist([]);
        }
        refIndexCode.current = indexCode;
        _getDatas(indexCode);
    }, [indexCode])

    //
    return (
        <AutoSizer>
            {({ height, width }) => {
                return (
                    <div className="tbl__popup" style={{height: height, width: width}}>
                        <div className="scroll-styled">
                            <table className="tb-sticky sticky-left">
                                <thead>
                                    <tr>
                                        <th className="text-left">{t('ngay')}</th>
                                        <th className="text-right">{t('thayDoi')}</th>
                                        <th className="text-right">%</th>
                                        <th className="text-right">{t('mo')}</th>
                                        <th className="text-right">{t('cao')}</th>
                                        <th className="text-right">{t('thap')}</th>
                                        <th className="text-right">{t('dong')}</th>
                                        <th className="text-right">{t('tongKLKhop')}</th>
                                        <th className="text-right">{t('tongGTKhop')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {displayDatas && displayDatas.map((item, index) => {
                                        const _changeClr = item.currentIndex != 0 ? getColorByIndex(item.currentIndex, item.priorIndex) : '';
                                        const _openClr = item.openIndex != 0 ? getColorByIndex(item.openIndex, item.priorIndex) : '';
                                        const _highestClr = item.highestIndex != 0 ? getColorByIndex(item.highestIndex, item.priorIndex) : '';
                                        const _lowestClr = item.lowestIndex != 0 ? getColorByIndex(item.lowestIndex, item.priorIndex) : '';
                                        const _closeClr = item.closeIndex != 0 ? getColorByIndex(item.closeIndex, item.priorIndex) : '';

                                        return (
                                            <tr key={index}>
                                                <td className={"text-left"}>{item.tradingDate}</td>
                                                <td className={"text-right " + _changeClr}>{formatNumber_N1(item.changeIndex)}</td>
                                                <td className={"text-right " + _changeClr}>{formatNumber_N1(item.pctChangeIndex)}</td>
                                                <td className={"text-right " + _openClr}>{formatNumber_N1(item.openIndex)}</td>
                                                <td className={"text-right " + _highestClr}>{formatNumber_N1(item.highestIndex)}</td>
                                                <td className={"text-right " + _lowestClr}>{formatNumber_N1(item.lowestIndex)}</td>
                                                <td className={"text-right " + _closeClr}>{formatNumber_N1(item.closeIndex)}</td>
                                                <td className={"text-right"}>{formatNumber_N1(item.totalTradedQtty)}</td>
                                                <td className={"text-right"}>{formatNumber_N1(item.totalTradedValue)}</td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )
            }}
        </AutoSizer>
    )
}, (prevProps, nextProps) => {
    if (prevProps.indexCode === nextProps.indexCode) {
        return true;
    }
    return false;
})
